export { default as TinTuc } from './tinTuc';
export { default as TinTucNew } from './tinTuc_new';
export { default as Comment } from './comment';
export { default as DuAn } from './duAn';
export { default as LoaiDuAn } from './loaiDuAn';
export { default as DanhMuc } from './danhMuc';
export { default as TinQuanTam } from './tinQuanTam';
